// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"75ac0964","725":"322fdd29"}[chunkId] + ".chunk.js";
};